import React from "react";
import { Lock, Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function GatedFeature({ tier = "platinum", title, subtitle }) {
  const navigate = useNavigate();
  return (
    <div
      data-testid="gated-feature"
      className="glass-card-strong p-8 text-center fade-up"
      style={{ boxShadow: "var(--glow-purple)" }}
    >
      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-5"
           style={{ background: "rgba(123,31,162,0.18)", boxShadow: "var(--glow-purple)" }}>
        <Lock size={28} className="text-white" strokeWidth={1.6} />
      </div>
      <h2 className="text-2xl font-bold mb-2">{title}</h2>
      <p className="text-soft mb-6">{subtitle}</p>
      <button
        data-testid="upgrade-cta"
        onClick={() => navigate("/subscription")}
        className="btn-gold inline-flex items-center gap-2"
      >
        <Sparkles size={16} /> Upgrade to {tier === "premium" ? "Premium" : "Platinum"}
      </button>
    </div>
  );
}
